/**
 * Website translations for German and English
 * German is the default language
 */
const translations = {
  de: {
    // Header (Issue #423 — remove `header.betaCta` after beta-test phase)
    header: {
      betaCta: 'Beta testen'
    },

    // Hero Section
    hero: {
      titleStart: 'Die Studenten-Community',
      titleEnd: 'für ein',
      titleHighlight: ' leichteres Uni-Leben',
      description: 'Tausche dich über alles mit Kommilitonen deiner Hochschule aus - wenn du willst, anonym',
      ctaButton: 'Teste unsere Beta und gewinne einen Amazon-Gutschein',
      ctaButtonShort: 'Teste\u00A0&\u00A0Gewinne\u00A0Gutscheine'
    },

    // Feature Section 1 - Community
    community: {
      title: {
        highlight: 'Nur wir.',
        rest: ' Keine Fremden.'
      },
      description: 'Universe verbindet dich mit Studenten deiner Hochschule — exklusiv für verifizierte\u00A0Studenten',
      subFeature1: {
        title: 'Nur verifizierte Studenten',
        description: 'Jeder Nutzer wird als Student deiner Hochschule verifiziert – so weißt du immer, mit wem du sprichst, und kannst dich auf die Community\u00A0verlassen.'
      },
      subFeature2: {
        title: 'Anonym für mehr Freiheit',
        description: 'Poste frei. Frag offen. Teile ehrlich – auf Wunsch\u00A0anonym'
      }
    },

    // Feature Section 2 - Marketplace
    marketplace: {
      title: {
        start: 'Online Flohmarkt ',
        highlight: 'auf dem Campus'
      },
      description: 'Im Universe Marktplatz findest du alles, was du brauchst auf dem Campus, von WG-Zimmern und Fachbüchern bis zu Fahrrädern oder Tickets.',
      subFeature1: {
        title: 'Klarnamen. Klarer Deal.',
        description: 'Im Marktplatz handeln alle mit Klarnamen — damit du weißt, mit wem du\u00A0sprichst.'
      }
    },

    // Feature Section 3 - Course Reviews
    reviews: {
      title: {
        start: 'Keine ',
        highlight: 'Kurs-Fails',
        end: ' mehr.'
      },
      description: 'Lies echte Erfahrungen zu Kursen deiner Hochschule, bevor du dich\u00A0anmeldest.',
      subFeature1: {
        title: 'Teile dein Success und Fails',
        description: 'Teile deine Erfahrungen, Einblicke und Tipps zu deinen belegten Kursen und hilfe anderen Studenten.'
      }
    },

    // Beta Test Section
    betaTest: {
      line1Start: 'Nimm am ',
      line1Highlight: 'Beta-Test',
      line1End: ' teil.',
      line2Start: 'Gewinne einen ',
      line2Highlight: 'Amazon-Gutschein',
      line2End: '!',
      description: 'Wir suchen Studierende der HAW Kiel und TU Hamburg für unseren Beta-Test. Der Beta-Test ist komplett anonym – wir sammeln keine persönlichen Daten. Wir freuen uns auf deine Erfahrungen in Universe und dein Feedback!',
      ctaButton: 'Anmelden'
    },

    // Social Media Section
    social: {
      titleStart: 'Unileben ist',
      titleHighlight: 'leichter,',
      titleMiddle: 'wenn du',
      titleHighlight2: 'nicht allein',
      titleEnd: 'bist.',
      cta: 'Wir bauen eine Studenten\u2011Community. Sei von Anfang an\u00A0dabei.',
      instagramCta: 'Folge uns auf Instagram'
    },

    // Footer
    footer: {
      ctaTitle: 'Bevor du gehst, mach bei unserem Beta-Test mit!',
      ctaDescription: 'Starte kostenlos. Füge dein ganzes Team hinzu, wenn du mehr brauchst.',
      ctaButton: 'Am Beta-Test teilnehmen',
      language: 'Deutsch',
      termsAndConditions: 'AGB',
      privacyPolicy: 'Datenschutzerklärung',
      communityGuideline: 'Community-Richtlinie',
      impressum: 'Impressum',
      copyright: 'GAIA Software UG (haftungsbeschränkt)'
    },

    // Location Section
    location: {
      title: {
        start: 'Wir starten ',
        highlight: 'im Norden.',
        end: ''
      },
      description: 'Die Beta startet mit Studenten der TU Hamburg und HAW Kiel. Entdecke UNIVERSE 7 Tage lang — anonym und\u00A0exklusiv.',
      ctaButton: 'Jetzt Beta ausprobieren'
    },

    // Accessibility
    a11y: {
      skipToContent: 'Zum Hauptinhalt springen',
      heroImageAlt: 'Studierende, die zusammen lachen und kommunizieren',
      feedScreenAlt: 'UNIVERSE App Feed-Ansicht mit anonymen Beiträgen von Studierenden',
      marketplaceScreenAlt: 'UNIVERSE Marktplatz-Ansicht mit Wohnungsangeboten für Studierende',
      reviewsScreenAlt: 'UNIVERSE Kursbewertungen-Ansicht mit studentischen Bewertungen',
      locationMapAlt: 'Karte von Norddeutschland mit markierten Standorten Kiel und Hamburg',
      footerNavLabel: 'Footer-Navigation',
      languageSelectLabel: 'Sprachauswahl',
      instagramLabel: 'Folge uns auf Instagram',
      betaButtonLabel: 'Jetzt am Beta-Test teilnehmen',
      tryBetaLabel: 'Jetzt die Beta-Version ausprobieren',
      registrationImageAlt: 'Illustration einer Person, die ein Anmeldeformular ausfüllt',
      emailNotificationImageAlt: 'Illustration einer E-Mail-Benachrichtigung',
      exploreImageAlt: 'Illustration einer Person, die eine App erkundet',
      amazonGiftCardImageAlt: 'Amazon-Gutschein Illustration',
      // Issue #423 — remove after beta-test phase
      betaCtaLabel: 'Zum Beta-Test springen'
    },

    // Beta Test Page
    betaTestPage: {
      hero: {
        titleLine1Start: 'Entdecke ',
        titleLine1Highlight: 'UNIVERSE.',
        titleLine2: '7 Tage,\u00A0anonym.',
        description: 'Unsere Beta ist offen für Studenten der TU Hamburg und HAW Kiel. Unter allen Teilnehmern verlosen wir Amazon-Gutscheine. Entdecke die exklusive Studenten-Community, für 7\u00A0Tage und ganz\u00A0anonym.',
        ctaButton: 'Jetzt Anmelden'
      },
      guideline: {
        title: 'So funktioniert\u00A0es.',
        step1: {
          title: '1.\u00A0Anmeldung',
          description: 'Fülle das Anmeldeformular aus. Wir brauchen nur zwei Angaben: deine Hochschule und\u00A0E\u2011Mail\u00A0Adresse.'
        },
        step2: {
          title: '2.\u00A0Einladung per\u00A0E\u2011Mail',
          description: 'Nach deiner Anmeldung schicken wir dir eine E\u2011Mail mit dem Download-Link, deinen Zugangsdaten und allen Infos zum\u00A0Beta\u2011Test.'
        },
        step3: {
          title: '3.\u00A0Entdecken',
          description: 'Nachdem du die App heruntergeladen hast, kannst du dich mit den Zugangsdaten deines Testkontos anmelden. Ab deinem ersten Login hast du 7\u00A0Tage Zeit, UNIVERSE frei zu\u00A0erkunden.'
        },
        step4: {
          title: '4.\u00A0Feedback &\u00A0Verlosung',
          description: 'Nach 7\u00A0Tagen wird dein Testkonto automatisch gelöscht. Danach schicken wir dir eine kurze Umfrage zu deinen Erfahrungen mit Universe.',
          raffleTitle: 'Ein Dankeschön für dein Feedback',
          raffleDescription: 'Am Ende der Umfrage kannst du an einer Verlosung teilnehmen, bei der du einen Amazon-Gutschein im Wert von 5\u00A0€ gewinnen kannst. Zwei der Tester mit dem hilfreichsten Feedback erhalten einen Amazon-Gutschein im Wert von\u00A025\u00A0€!'
        }
      },
      registration: {
        title: 'Interesse? Melde\u00A0dich\u00A0hier\u00A0an.',
        universityLabel: 'Hochschule',
        universityPlaceholder: 'Wähle deine Hochschule',
        // Issue #392: Beta is restricted to TUHH/HAW Kiel student emails.
        emailLabel: 'Deine Studenten E\u2011Mail Adresse',
        emailPlaceholder: 'Gib deine E\u2011Mail-Adresse ein',
        submitButton: 'Anmelden',
        successMessage: 'Erfolgreich angemeldet. Du bekommst eine E\u2011Mail mit deinem Test\u00A0Account von unserem Team. Vielen\u00A0Dank!',
        emailAlreadyRegistered: 'Diese E\u2011Mail\u00A0Adresse wurde bereits\u00A0angemeldet.',
        // Issue #392: Domain not whitelisted for beta test.
        emailInvalidDomain: 'Sorry, unser Beta-Test ist nur offen f\u00FCr die Studenten aus TUHH und HAW Kiel. Wir bem\u00FChen uns, dass unser Service auch f\u00FCr deine Uni bald verf\u00FCgbar ist!',
        // Issue #392: SMTP rejected the contact email immediately.
        emailSendFailed: 'Oops! Die Email mit dem Test Account konnte nicht gesendet werden. Bitte gib deine Studenten E-Mail Adresse korrekt ein.',
        // Issue #397: Selected university does not match the student email domain.
        emailUniversityMismatch: 'Die ausgewählte Universität passt nicht zu deiner Studenten E-Mail Adresse. Bitte wähle richtige Universität aus, in der du eingeschreiben bist.',
        universities: {
          tuhh: 'Technische Universität Hamburg\u00A0(TUHH)',
          hawKiel: 'Hochschule für Angewandte Wissenschaften\u00A0Kiel'
        }
      }
    }
  },

  en: {
    // Header (Issue #423 — remove `header.betaCta` after beta-test phase)
    header: {
      betaCta: 'Test beta'
    },

    // Hero Section
    hero: {
      titleStart: 'The student community',
      titleEnd: 'to make your',
      titleHighlight: ' uni life easier',
      description: 'Share, connect, meet people at your university anytime, anywhere and if you want,\u00A0anonymously',
      ctaButton: 'Try our Beta and win an Amazon gift card',
      ctaButtonShort: 'Test\u00A0&\u00A0Win\u00A0gift\u00A0cards'
    },

    // Feature Section 1 - Community
    community: {
      title: {
        highlight: 'Your uni.',
        rest: ' No outsiders.'
      },
      description: 'Universe connects you with students from your university — exclusively for verified\u00A0students',
      subFeature1: {
        title: 'Verified students only',
        description: 'Every user is verified as a student at your university, so you can communicate safely and trust who you\'re interacting\u00A0with.'
      },
      subFeature2: {
        title: 'Anonymous when you want',
        description: 'Post freely. Ask openly. Share honestly – anonymously if you\u00A0want'
      }
    },

    // Feature Section 2 - Marketplace
    marketplace: {
      title: {
        start: 'Everything you need - ',
        highlight: 'on campus'
      },
      description: 'Universe Marketplace lets you buy, sell, or find anything from fellow students at your university—from flats and textbooks to bikes or tickets.',
      subFeature1: {
        title: 'Real names. Real trust.',
        description: 'On the marketplace, everyone trades under their real name — so you know who you\'re talking\u00A0to.'
      }
    },

    // Feature Section 3 - Course Reviews
    reviews: {
      title: {
        start: 'No more ',
        highlight: 'course regrets',
        end: '.'
      },
      description: 'Read real experiences about courses at your university before you\u00A0sign\u00A0up.',
      subFeature1: {
        title: 'Share what matters.',
        description: 'Help other students by sharing your experiences, insights, and tips from courses you\'ve already\u00A0taken.'
      }
    },

    // Beta Test Section
    betaTest: {
      line1Start: 'Join the ',
      line1Highlight: 'beta test.',
      line1End: '',
      line2Start: 'Win an ',
      line2Highlight: 'Amazon gift card',
      line2End: '!',
      description: 'We are looking for students from HAW Kiel and TU Hamburg to participate in our Beta-Test. Beta-Test is conducted completely anonymously, not collecting your personal information. We are looking forward to your experience in Universe and your feedback!',
      ctaButton: 'Sign up'
    },

    // Social Media Section
    social: {
      titleStart: 'Uni life is',
      titleHighlight: 'easier',
      titleMiddle: 'when you\u2019re',
      titleHighlight2: 'not alone.',
      titleEnd: '',
      cta: 'We\u2019re building a student community. Be the first\u00A0insiders.',
      instagramCta: 'Follow us on Instagram'
    },

    // Footer
    footer: {
      ctaTitle: 'Before you leave, join our Beta-Test!',
      ctaDescription: 'Get started for free. Add your whole team as your needs grow.',
      ctaButton: 'Join Beta Test Now',
      language: 'English',
      termsAndConditions: 'Terms & Conditions',
      privacyPolicy: 'Privacy Policy',
      communityGuideline: 'Community Guideline',
      impressum: 'Impressum',
      copyright: 'GAIA Software UG (haftungsbeschränkt)'
    },

    // Location Section
    location: {
      title: {
        start: '',
        highlight: 'The north',
        end: ' goes first.'
      },
      description: 'The beta launches with students from TU Hamburg and HAW Kiel. Discover UNIVERSE for 7 days — anonymous and\u00A0exclusive.',
      ctaButton: 'Try Beta version Now'
    },

    // Accessibility
    a11y: {
      skipToContent: 'Skip to main content',
      heroImageAlt: 'Students laughing and communicating together',
      feedScreenAlt: 'UNIVERSE App feed view with anonymous student posts',
      marketplaceScreenAlt: 'UNIVERSE Marketplace view with housing offers for students',
      reviewsScreenAlt: 'UNIVERSE Course reviews view with student ratings',
      locationMapAlt: 'Map of Northern Germany with marked locations Kiel and Hamburg',
      footerNavLabel: 'Footer navigation',
      languageSelectLabel: 'Language selection',
      instagramLabel: 'Follow us on Instagram',
      betaButtonLabel: 'Join Beta-Test now',
      tryBetaLabel: 'Try Beta version now',
      registrationImageAlt: 'Illustration of a person filling out a registration form',
      emailNotificationImageAlt: 'Illustration of an email notification',
      exploreImageAlt: 'Illustration of a person exploring an app',
      amazonGiftCardImageAlt: 'Amazon gift card illustration',
      // Issue #423 — remove after beta-test phase
      betaCtaLabel: 'Jump to beta test'
    },

    // Beta Test Page
    betaTestPage: {
      hero: {
        titleLine1Start: 'Discover ',
        titleLine1Highlight: 'UNIVERSE.',
        titleLine2: '7\u00A0days, anonymous.',
        description: 'Our beta is open for students of TU Hamburg and HAW Kiel. Among all participants we will raffle Amazon gift\u00A0cards. Discover the exclusive student community for 7\u00A0days, completely\u00A0anonymous.',
        ctaButton: 'Sign up'
      },
      guideline: {
        title: 'Let me explain how it\u00A0works.',
        step1: {
          title: '1.\u00A0Registration',
          description: 'Fill in the registration form. We need only two information – your university and e\u2011mail\u00A0address.'
        },
        step2: {
          title: '2.\u00A0Get your test\u00A0account',
          description: 'After signing up, we will send you an email with the download link, your credentials and everything you need to know about the\u00A0beta-test.'
        },
        step3: {
          title: '3.\u00A0Explore',
          description: 'After downloading the app, you can log in with your test account credential. As of your first login, you have 7\u00A0days to freely explore UNIVERSE.'
        },
        step4: {
          title: '4.\u00A0Feedback &\u00A0Raffle',
          description: 'After 7\u00A0days of testing, your test account will be deleted automatically. After that we will send you a short survey about your experience with Universe.',
          raffleTitle: 'A thank-you for your feedback',
          raffleDescription: 'At the end of the survey, you can apply for a raffle to win a 5\u00A0€ Amazon gift card. Two of the testers with the most helpful feedback will get a 25\u00A0€\u00A0reward!'
        }
      },
      registration: {
        title: 'Interested? Sign\u00A0up\u00A0here.',
        universityLabel: 'University',
        universityPlaceholder: 'Select your university',
        // Issue #392: Beta is restricted to TUHH/HAW Kiel student emails.
        emailLabel: 'Your student email address',
        emailPlaceholder: 'Enter your email address',
        submitButton: 'Sign up',
        successMessage: 'Signed up successfully. You will get an email with your test account from our team soon. Thank\u00A0you!',
        emailAlreadyRegistered: 'This email address has already been\u00A0registered.',
        // Issue #392: Domain not whitelisted for beta test.
        emailInvalidDomain: 'Sorry, our beta test is currently only available for students from TUHH and HAW kiel. We do our best to open our service for your university soon!',
        // Issue #392: SMTP rejected the contact email immediately.
        emailSendFailed: 'Oops! The email with your test account could not be sent. Please enter a correct student email address.',
        // Issue #397: Selected university does not match the student email domain.
        emailUniversityMismatch: 'Selected university and your student email address do not match. Please select the right university that you are enrolled in.',
        universities: {
          tuhh: 'Technical University of Hamburg\u00A0(TUHH)',
          hawKiel: 'University of Applied Sciences\u00A0Kiel'
        }
      }
    }
  }
};

export default translations;
